/* 创建者 李伟(2018.2.03) */
<template>
  <div class="conInner">
    <section id="content_wrapper">
      <div class="data">
        <h2>我的积分</h2>
      </div>
      <!-- <div class="tip">
        <div class="top"></div>
        <div class="body">
          <img src="//static.kxymall.com/images/gth.jpg">
          <div>
            <h3>购物积分规则:</h3>
            <ol>
              <li>当购物积分已达到某一兑换购物积分标准时，顾客可将累计购物积分依照网站相应购物积分及兑换标准兑换回馈商品，网站将即时从用户会员购物积分中扣减相应购物积分。</li>
              <li>各项回馈项目（包含各项商品、服务或抵用券等）及兑换标准及兑换规则均以兑换当时最新回馈活动公告或目录为准。</li>
              <li>部分兑换商品有数量限制的，兑完为止。</li>
              <li>公告或目录如有有效期限的，逾期即不得兑换。</li>
              <li>购物积分兑换区的商品为只可用购物积分兑换的商品(如购物积分价格：100购物积分)</li>
            </ol>
          </div>
        </div>
        <div class="bottom"></div>
      </div> -->
      <div class="tab">
        <ul>
          <li class="selected">
            <a><span>我的积分</span></a>
          </li>
        </ul>
      </div>
      <div class="point_wrap white_box">
        <div class="box">
          <div class="top"></div>
          <div class="body">
            <div class="pointsSumm">
              <h4>购物积分</h4>
              <div class="overview">
                <p class="layerCol">
                  可用积分：<strong>{{ myPointData }}</strong>
                </p>
              </div>
            </div>
            <div class="pointsSumm" v-show="myCoupon">
              <h4>我的现金券</h4>
              <div class="overview">
                <p class="layerCol">
                  可用现金券：<strong style="color: red">
                    {{ myCoupon }}</strong
                  >
                </p>
              </div>
            </div>
            <div class="pointsSumm" v-show="shoppingBonusFlag == 1 || (shoppingBonusFlag == 2 && +shoppingBonus > 0)">
              <h4>购物奖励积分</h4>
              <div class="overview">
                <p class="layerCol">
                  可用购物奖励积分：<strong style="color: red">
                    {{ shoppingBonus }}</strong
                  >
                  <span
                    @click="shoppingBonusClick(8601)"
                    style="
                      margin-left: 24px;
                      background: #e4393c;
                      color: #fff;
                      display: inline-block;
                      padding: 4px 10px;
                      border-radius: 4px;
                      font-size: 13px;
                      cursor: pointer;
                    "
                    >明细</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="bottom"></div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { getMyPoint } from "api/user.js";
import { getSession } from "utils/tool";
export default {
  data() {
    return {
      myPointData: "",
      myCoupon: 0,
      shoppingBonus: 0,
      shoppingBonusFlag: null
    };
  },
  created() {
    this.getMyPointData();
  },
  methods: {
    shoppingBonusClick(type) {
      this.$router.push({
        path: "/point-item",
        query: {
          type: type,
        },
      });
    },
    getMyPointData: function () {
      // let postBody = this.$Rsa.encrypt(JSON.stringify({ loginName: getSession('userName') }))
      getMyPoint({}).then((json) => {
        this.myPointData = json.data.shopMoney;
        this.myCoupon = json.data.coupon;
        this.shoppingBonus = json.data.shoppingBonus;
        this.shoppingBonusFlag = json.data.userDetailSwitchVO.shoppingBonus
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// shoppingScore.vue?d52c1b8c